import './chat.css';
import { Link, useNavigate } from 'react-router-dom';
import { t } from '../../i18n';
import { joinNames, shorten } from '../../lib/format';
import { allContacts, appChat, appOpenThread, chatPath, unreadOf, writableContacts } from './data';

// Teile der Übersicht, die zum Chat gehören. Ohne clientId: alle Firmen dieses Logins.

// Hinweis oben: „Neue Nachricht von …“ mit Vorschau und „Lesen“.
export function ChatNotice({ clientId }: { clientId?: string }) {
  const data = appChat.useData();
  const open = appOpenThread.useOpen();
  const navigate = useNavigate();
  const contacts = allContacts(data).filter((c) => !clientId || c.clientId === clientId);
  const total = contacts.reduce((n, c) => n + unreadOf(c, open), 0);
  if (total === 0) return null;
  // Der Chat mit der neuesten ungelesenen Nachricht
  const latest = contacts
    .filter((c) => unreadOf(c, open) > 0 && c.lastIncoming)
    .sort((a, b) => b.lastIncoming!.at.localeCompare(a.lastIncoming!.at))[0];
  const text = latest?.lastIncoming?.text;
  return (
    <div className="notice" role="status">
      <div className="nt-r">
        <span className="nt-i" aria-hidden="true">
          ✉
        </span>
        <div className="tx">
          <b>
            {total === 1
              ? latest
                ? t('Neue Nachricht von {name}', { name: latest.name })
                : t('Neue Nachricht von Ihrer Kanzlei')
              : t('{n} neue Nachrichten von Ihrer Kanzlei', { n: total })}
          </b>
          {text && <small>„{shorten(text, 90)}“</small>}
        </div>
        <button
          type="button"
          className="btn2 dark"
          onClick={() => navigate(latest ? chatPath(latest.clientId, latest.id) : '/app/nachrichten')}
        >
          {t('Lesen')}
        </button>
      </div>
    </div>
  );
}

// Eintrag „Nachrichten“ in der Liste der Bereiche.
export function ChatListItem({ clientId }: { clientId?: string }) {
  const data = appChat.useData();
  const open = appOpenThread.useOpen();
  const contacts = allContacts(data).filter((c) => !clientId || c.clientId === clientId);
  const unread = contacts.reduce((n, c) => n + unreadOf(c, open), 0);
  const names = writableContacts(data)
    .filter((c) => !clientId || c.clientId === clientId)
    .map((c) => c.name);
  return (
    <Link to="/app/nachrichten" className="item">
      <span className="ico" aria-hidden="true">
        ✉
      </span>
      <span className="tx">
        <b>{t('Nachrichten')}</b>
        <small>{names.length ? t('Chat mit {names}', { names: joinNames(names) }) : t('Chat mit Ihrer Kanzlei')}</small>
      </span>
      {unread > 0 && (
        <span className="unread">
          {unread}
          <span className="sr-only"> {t('ungelesen')}</span>
        </span>
      )}
      <span className="chev" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
